/* hotbrands - miniaturas das outras cores do mesmo produto (cartoes + pagina de produto) */
(function () {
  var CACHE_KEY = 'hb_sw_v2';
  var COLORS = ['marinho', 'bege', 'cinzento', 'cinzenta', 'cinzentos', 'cinzentas', 'cinza', 'preto', 'preta', 'pretos', 'pretas', 'branco', 'branca', 'brancos', 'brancas', 'verde', 'verdes', 'amarelo', 'amarela', 'amarelos', 'amarelas', 'azul', 'azuis', 'bordo', 'caqui', 'castanho', 'castanha', 'creme', 'vermelho', 'vermelha', 'rosa', 'laranja', 'roxo', 'lilas', 'dourado', 'prateado', 'turquesa', 'salmao'];

  function norm(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function baseOf(title) {
    var w = norm(title).replace(/\bcalcoes\b/g, 'calcao').replace(/\bt-shirts\b/g, 't-shirt').split(/\s+/).filter(Boolean);
    var i = -1;
    for (var k = 0; k < w.length; k++) {
      if (COLORS.indexOf(w[k]) > -1) { i = k; break; }
    }
    return i > 0 ? w.slice(0, i).join(' ') : null;
  }

  function colorName(title) {
    var w = title.split(/\s+/).filter(Boolean);
    for (var k = 0; k < w.length; k++) {
      if (COLORS.indexOf(norm(w[k])) > -1) { return w.slice(k).join(' '); }
    }
    return title;
  }

  function getData() {
    try {
      var c = sessionStorage.getItem(CACHE_KEY);
      if (c) return Promise.resolve(JSON.parse(c));
    } catch (e) {}
    return fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = j.products.map(function (p) {
          return { t: p.title, h: p.handle, i: (p.images && p.images[0] && p.images[0].src) || '' };
        });
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(d)); } catch (e) {}
        return d;
      });
  }

  function buildMaps(data) {
    var groups = {}, byH = {};
    data.forEach(function (p) {
      byH[p.h] = p;
      var b = baseOf(p.t);
      if (!b) return;
      (groups[b] = groups[b] || []).push(p);
    });
    return { groups: groups, byH: byH };
  }

  function thumb(s, size, current) {
    var el = document.createElement(current ? 'span' : 'a');
    el.className = 'hb-color' + (current ? ' is-current' : '');
    if (!current) { el.href = '/products/' + s.h; }
    el.title = s.t;
    el.setAttribute('aria-label', s.t);
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = s.t;
    img.src = s.i ? s.i + (s.i.indexOf('?') > -1 ? '&' : '?') + 'width=' + size : '';
    el.appendChild(img);
    return el;
  }

  function injectCards(maps) {
    var cards = document.querySelectorAll('.card');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.querySelector('.card__colors')) return;
      var a = card.querySelector('a.card__media') || card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var p = maps.byH[decodeURIComponent(m[1])];
      if (!p) return;
      var b = baseOf(p.t);
      if (!b) return;
      var sib = (maps.groups[b] || []).filter(function (x) { return x.h !== p.h; });
      if (!sib.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'card__colors';
      sib.slice(0, 5).forEach(function (s) { wrap.appendChild(thumb(s, 120, false)); });
      var anchor = card.querySelector('.card__price') || card.querySelector('.card__title');
      if (anchor) { anchor.insertAdjacentElement('afterend', wrap); } else { card.appendChild(wrap); }
    });
  }

  function injectProductPage(maps) {
    var form = document.querySelector('.product__form');
    if (!form || document.querySelector('.pdp__colors')) return;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var p = maps.byH[decodeURIComponent(m[1])];
    if (!p) return;
    var b = baseOf(p.t);
    if (!b) return;
    var group = maps.groups[b] || [];
    if (group.length < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'option pdp__colors';
    var label = document.createElement('label');
    label.textContent = 'Cor: ' + colorName(p.t);
    wrap.appendChild(label);
    var row = document.createElement('div');
    row.className = 'pdp__colors-row';
    group.forEach(function (s) { row.appendChild(thumb(s, 160, s.h === p.h)); });
    wrap.appendChild(row);
    var opts = form.querySelector('.product__options');
    if (opts) { opts.insertAdjacentElement('afterbegin', wrap); } else { form.insertAdjacentElement('afterbegin', wrap); }
  }

  var st = document.createElement('style');
  st.textContent = '.card__colors{display:flex;gap:.4rem;margin:.4rem 0 0;flex-wrap:wrap}' +
    '.card__colors .hb-color{width:26px;height:26px}' +
    '.hb-color{border-radius:50%;overflow:hidden;display:block;border:1px solid rgba(0,0,0,.18);flex:none;transition:border-color .15s ease,transform .15s ease}' +
    'a.hb-color:hover{border-color:rgba(0,0,0,.7);transform:scale(1.1)}' +
    '.hb-color img{width:100%;height:100%;object-fit:cover;transform:scale(2.1);transform-origin:center 42%;display:block}' +
    '.pdp__colors{margin-bottom:1rem}' +
    '.pdp__colors-row{display:flex;gap:.55rem;flex-wrap:wrap;margin-top:.35rem}' +
    '.pdp__colors-row .hb-color{width:40px;height:40px}' +
    '.pdp__colors-row .hb-color.is-current{border:2px solid #111;box-shadow:0 0 0 2px #fff inset}';
  document.head.appendChild(st);

  function run() {
    getData().then(function (data) {
      var maps = buildMaps(data);
      injectCards(maps);
      injectProductPage(maps);
    }).catch(function (e) {});
  }

  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();
